<div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>

        <!-- <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'id' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.id}} </td>
        </ng-container> -->

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'name' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.fullName}} </td>
        </ng-container>

        <ng-container matColumnDef="userName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'userName' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.userName}} </td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'email' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.email}} </td>
        </ng-container>

        <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'phone' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.phoneNumber}} </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'status' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.status == 1 ? 'فعال' : 'غير فعال'}} </td>
        </ng-container>

        <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'role' | translate}} </th>
            <td mat-cell *matCellDef="let row"> {{row.role}} </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 10%;"> {{'action' | translate}} </th>
            <td mat-cell *matCellDef="let row" style="width: 10%;">

                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">

                    <button mat-menu-item (click)="onDeactivate(row.id,row.status)">
                        <mat-icon> {{row.status == 0 ? 'done' : 'block'}}</mat-icon>
                        {{row.status == 0 ? ('activate' | translate) : ('unActive' | translate)}}
                    </button>

                    <button mat-menu-item (click)="onEdit(row)">
                        <mat-icon> edit</mat-icon>
                        {{'edit' | translate}}
                    </button>


                </mat-menu>
            </td>
        </ng-container>

        <!-- <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef style="width: 10%;">
                <span>Action</span>
            </th>
            <td mat-cell *matCellDef="let row;let i = index;" style="width: 10%;padding: 10px;">
                <button mat-raised-button color="primary" (click)="onDeactivate(row.id,row.status)">

                    <mat-icon *ngIf="row.status == 0">done</mat-icon>
                    <mat-icon *ngIf="row.status == 1">block</mat-icon>

                    <span *ngIf="row.status == 1 ">{{'unActive' | translate}}</span>
                    <span *ngIf="row.status == 0 ">{{'activate' | translate}}</span>


                </button>
            </td>
        </ng-container> -->


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}} </td>
        </tr>
    </table>

    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>

<ng-template #editModal>

    <h1 mat-dialog-title>{{'update' | translate}}</h1>
    <div mat-dialog-content>

        <mat-form-field appearance="standard">
            <mat-label>{{'name' | translate}}</mat-label>
            <input matInput [(ngModel)]="editName">
            <!-- <mat-error *ngIf="arabName.invalid">{{'requiredField' | translate}}</mat-error> -->
        </mat-form-field>

        <mat-form-field appearance="standard">
            <mat-label>{{'email' | translate}}</mat-label>
            <input matInput [(ngModel)]="editEmail" #email="ngModel">
            <mat-error *ngIf="email.invalid">{{'requiredField' | translate}}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="standard">
            <mat-label>{{'phone' | translate}}</mat-label>
            <input matInput [(ngModel)]="editPhone" #edit_phone="ngModel">
            <mat-error *ngIf="edit_phone.invalid">{{'requiredField' | translate}}</mat-error>
        </mat-form-field>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-raised-button color="primary" cdkFocusInitial [disabled]="email.invalid || edit_phone.invalid"
            (click)="updateUserInfo()">{{'submit' | translate}}</button>
    </div>

</ng-template>

<ng-template #ModalConfirmApprove [direction]="ltr">

    <h1 mat-dialog-title>Confirm</h1>
    <div mat-dialog-content>
        <p>The confirm token was sent by SMS</p>

        <mat-form-field appearance="standard">
            <mat-label>{{'otpConfirm' | translate}}</mat-label>
            <input matInput [(ngModel)]="otpConfirm" />
        </mat-form-field>


    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">Cancel</button>
        &nbsp;
        <button mat-raised-button color="primary" cdkFocusInitial (click)="confirmActivatUser()">
            Confirm</button>
        &nbsp;
        <button mat-button (click)="resendOTP()" *ngIf="counterEnd">Resend</button>
        <span *ngIf="!counterEnd">{{otpCounter}}</span>
    </div>

</ng-template>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>